export const APP_CONFIG_LOCAL_STORAGE_TTL = 15;
export const APP_CONFIG_UPDATED_TIME = "appConfigUpdatedTime";
export const IS_ADS_ENABLED = "isAdsEnabled";
export const REQUISITION_CATEGORY = "REQUISITION_CATEGORY";
export const IS_JC_ENABLED = "isJobContainerEnabled";
export const IS_ATOZ_ENABLED = "isAtoZEnabled";
export const WORK_AUTHORIZATION_DOC_CONFIGS =
  "workAuthorizationDocumentConfigs";
export const HIDE_ATOZ_TASK = "hideAtoZTask";
export const TASK_FEATURE_FLAG_CONFIG = "task_feature_flag_config";
export const BADGE_PHOTO_TASK_ID = "BADGE_PHOTO_TASK";
export const I9_TASK_ID = "I9_TASK";
export const NHE_VIDEO_TASK_ID = "NHE_VIDEO_TASK";
export const PACKAGE_I9_TASK_ID = "PACKAGE_I9_TASK";
export const BP_DURING_APPOINTMENT_TASK_ID = "BP_DURING_APPOINTMENT_TASK";
export const BGC_CHECK_IN_SCREENING_TASK_ID = "BGC_CHECK_IN_SCREENING_TASK";
export const AIR_BGC_IN_SCREENING_CHECK_TASK_ID =
  "AIR_BGC_IN_SCREENING_CHECK_TASK";
export const DT_IN_SCREENING_CHECK_TASK_ID = "DT_IN_SCREENING_CHECK_TASK";
export const PIC_IN_SCREENING_CHECK_TASK_ID = "PIC_IN_SCREENING_CHECK_TASK";
export const MYSP_TASK_ID = "MYSP_TASK";
export const EMPLOYMENT_PAPERWORK_TASK_ID = "EMPLOYMENT_PAPERWORK_TASK";
export const ATOZ_TASK_ID = "ATOZ_TASK";
export const DOCUMENT_TASK_ID = "DOCUMENT_TASK";
export const APPOINTMENT_DETAILS_TASK_ID = "APPOINTMENT_DETAILS_TASK";
export const MEDICAL_CHECK_IN_SCREENING_TASK_ID =
  "Medical_CHECK_IN_SCREENING_TASK";
export const CUSTOMER_SERVICE = "Customer Service";
